import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { DispatchVolumeChartData } from '../../models/dashboard/dashboard/dispatcher-volume-data';

interface IInitialState {
  dispatchVolumeData: DispatchVolumeChartData[];
}

const initialState: IInitialState = {
  dispatchVolumeData: []
};

const dispatchVolumeDataSlice = createSlice({
  name: 'dispatchVolumeDataSlice',
  initialState,
  reducers: {
    setDispatchVolumeData(state, action: PayloadAction<DispatchVolumeChartData[]>) {
      state.dispatchVolumeData = action.payload;
    },
  },
});

export const dispatchVolumeDataActions = dispatchVolumeDataSlice.actions;
export default dispatchVolumeDataSlice.reducer;
